<template>
  <div class="r-fabric-filter">
    <Modal
      :draggable="false"
      footer-hide
      :mask-closable="false"
      :styles="{ top: 0, width: '100%' }"
      v-model="show"
    >
      <div class="title-box">
        <div class="title">{{ $t("order.filter") }}</div>
        <div @click="close" class="common-hover iconfont iconguanbi"></div>
      </div>
      <!-- 搜索项 -->
      <div class="search-item">
        <!-- 用户 -->
        <div class="common-flex search">
          <div class="search-label">{{ $t("user.accountSearch.subAccount") }}</div>
          <div class="list common-flex common-flex-wrap">
            <div
              class="list-item common-hover"
              :class="item.id == searchItem.category ? 'list-item-choose' : ''"
              v-for="(item,index) in productList"
              :key="index"
              @click="changeProduct(item)"
            >
              {{item.name}}
            </div>
          </div>
        </div>
      </div>

      <div class="common-flex common-justify-center options">
        <div class="back options-btn common-hover" @click="close">
          {{ $t("order.back") }}
        </div>
        <div class="save options-btn common-hover" @click="search">
          {{ $t("order.search") }}
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "r-fabric-filter",
  data() {
    return {
      show: true,   
      searchItem: {
        category:''
      },
      productList:[],
    };
  },
  watch: {
    filteShow: {
      handler(newold, oldval) {
        this.show = newold;
        this.searchItem = JSON.parse(JSON.stringify(this.params));

      },
      immediate: true,
    },
    params: {
      handler(newold, oldval) {
        console.log('this.params',this.params)
      },
      immediate: true,
      deep:true
    },
  },
  props: {
    filteShow: Boolean,
    params: Object,
  },
  mounted(){
    this.dictbasicList()
  },
  methods: {
    ...mapActions([
      'dictbasicListAction',//获得产品分类
    ]),
    // 修改用户
    changeProduct(e){
      this.searchItem.category = e.id
    },
    // 关闭弹框
    close() {
      // for(let key in this.searchItem){
      //   this.searchItem[key] = ''
      // }
      this.$emit("close");
    },
    // 获得当前子账号
    dictbasicList(){
      this.dictbasicListAction({
        category:8,
        parentId:0
      }).then(res=>{
        res.data.unshift({
          id:'',
          name:this.$t('all')
        })
        this.productList = res.data
        console.log('this.productList',res.data)
      })
    },
    // 搜索
    search() {
      this.$emit('search',this.searchItem)
    },
    changeDate(e) {
      // this.searchItem.dealStart = e[0];
      // this.searchItem.dealEnd = e[1];
      // console.log("changeDate", e);/
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-icon-ios-close {
  display: none;
}
/deep/.ivu-modal-content {
  border-radius: 0;
}
/deep/.ivu-modal-body {
  padding: 0;
}
.title-box {
  height: 84px;
  text-align: center;
  font-size: 20px;
  font-family: Roboto;
  font-weight: 600;
  color: #081938;
  line-height: 84px;
  letter-spacing: 2px;
  // line-height: 84px;
  border-bottom: 1px solid #e6e8eb;
  position: relative;
  .iconguanbi {
    width: 84px;
    height: 84px;
    text-align: center;
    line-height: 84px;
    font-size: 14px;
    color: #081938;
    position: absolute;
    right: 0;
    top: 0;
    border-left: 1px solid #e6e8eb;
  }
}
.options {
  position: relative;
  // width: 1130px;
  margin: 20px auto;
  padding-bottom: 25px;
  .options-btn {
    width: 116px;
    height: 40px;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
    background: #b5bac4;
    margin: 0 7px;
  }
  .save {
    background: #0a4dcc;
  }
}
.search-item {
  width: 1140px;
  margin: 24px auto 60px;
  .search-date {
    border-bottom: 1px solid rgba(8, 25, 56, 0.1);
    > div {
      margin-right: 39px;
      padding-bottom: 18px;
    }
    .date-title {
      font-size: 14px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #081938;
      margin-right: 11px;
    }
  }
  .search {
    padding: 18px 0 0 0;
    // padding-bottom: 18px;
    // border-bottom: 1px dashed rgba(8, 25, 56, 0.1);
    .search-label {
      white-space: nowrap;
      font-size: 14px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #081938;
      line-height: 30px;
      margin-right: 15px;
      min-width: 120px;
    }
    .list {
      .list-item {
        margin-bottom: 24px;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
      }
      .list-item-choose {
        color: #fff;
        background: #0a4dcc;
        border-radius: 3px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-fabric-filter.vue